<template>
  <div class="analysisApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="link">
      <h2>请复制原文链接</h2>
      <p>目前仅支持：微信公众号、腾讯新闻、今日头条、百度新闻、laife分享内容（部分文章存在解析失败现象，敬请谅解），如有侵权行为，发布人承担相关责任</p>
      <el-input class="textarea" type="textarea" :rows="5" placeholder="请点击喜欢的微信公众号文章有上角更多进行复制，并粘贴到这里" v-model="textarea"></el-input>
      <p class="curt">点击开始编辑即为同意<font @click="$router.push('agree')">责任声明及解析文章协议</font></p>
      <el-button class="start" type="primary" @click="start">开始解析</el-button>
      <div class="record" @click="$router.push('record')">历史记录</div>
    </div>

    <!--<div class="intro">
      <h2>如何获取文章链接</h2>
      <p>· 打开准备转载的文章，点击屏幕右上角[...];在弹出的菜单选择[复制链接]。</p>
      <img src="~assets/images/shareIntro.png" />
    </div>-->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        textarea: '',
        userData:[]
      };
    },
    beforeMount() {
    },
    mounted() {
      this.beforeMount();
    },

    methods: {
      jump:function(index,url){
        this.$router.push({
          path:url,
         query:{
           id:index
         }
        })
      },
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.baseUrl = this.$host;
        if(localStorage.getItem('userjwt') == null){
          this.open()
        }else{
          var user = JSON.parse(localStorage.getItem('userjwt'));
          if(user.role != 1 && user.role != 4){
            this.$alert('您暂无权限撰写', '警告', {
              confirmButtonText: '确定',
              showClose:false,
              callback: action => {
                this.$router.push('write');return false;
              }
            })
          }
        }
      },
      created(){
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      },
      start:function(){
        if(this.textarea == ''){
          this.$alert('请输入解析地址！', '警告', {
            confirmButtonText: '确定',
            showClose:false,
            callback: action => {
            }
          })
          return false;
        }
        var that = this;
        var userData = JSON.parse(localStorage.getItem('userjwt'));
        that.fullscreenLoading = true;
        this.axios({
          'url': that.$host+'wx/news/reptile',
          'method': 'post',
          params:{
            userId:userData.id,
            urls:that.textarea
          }
        }).then(function(response){
          var res = response.data;
          if(res.status === '200'){
            that.jump(res.data,'wDetail')
          }else{
            that.$alert('请根据要求输入地址', '警告', {
              confirmButtonText: '确定',
              showClose:false,
              callback: action => {
              }
            })
          }
          that.fullscreenLoading = false;
         
        }).catch(err=>{
          that.fullscreenLoading = false;
        });
      },
      open:function() {
        this.$alert('请先登录！', '警告', {
          confirmButtonText: '确定',
          showClose:false,
          callback: action => {
            var url = encodeURIComponent('http://user.laife.cn/main/login');
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf57bae009c299252&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
            return;
          }
        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .analysisApp{
    max-width:640px;
    background:#f7f9fa;
    margin:0 auto;
  }
  .analysisApp .link{
    background:#fff;
    padding:0 4%
  }
  .analysisApp .link h2{
    display:block;
    font-size:18px;
    padding:15px 0 10px 0;
  }
  .analysisApp .link p{
    display:block;
    font-size:14px;
    font-weight:bold;
    padding-bottom:10px;
    letter-spacing: 1px
  }
  .analysisApp .link .textarea textarea{
    border:none;
    background:#f7f9fa;
    border-radius:8px !important;
    resize:none;
    color:#333;
    font-size:15px;
    outline:none;
  }
  .analysisApp .link p.curt{
    color:#8d95a1;
    padding-top:10px;
    font-size:13px;
  }
  .analysisApp .link p.curt font{
    color:#333;
    padding-left:10px;
  }
  .analysisApp .link .start{
    display:block;
    padding:12px 15px;
    width:100%;
    font-size:14px;
    font-weight:bold;
    margin-top:5px;
  }
  .analysisApp .link .record{
    color:#006ee4;
    font-size:14px;
    font-weight:bold;
    text-align:center;
    padding:15px 0
  }
  .analysisApp .intro{
    width:92%;
    display:block;
    margin:0 auto;
    padding-bottom:20px;
  }
  .analysisApp .intro h2{
    font-size:18px;
    color:#14294e;
    padding-top:15px;
  }
  .analysisApp .intro p{
    font-size:14px;
    color:#14294e;
    padding:10px 0;
  }
  .analysisApp .intro img{
    display:block;
    width:100%;
  }
</style>